/**
 * Shared status vocabulary for Elite topic content (elite_topic_content.status).
 * Used by the Generation Monitor's right-hand panel AND the full-screen
 * Content Workspace so both surfaces speak the same colours and words.
 */
export const TOPIC_STATUS_TONES = {
  NONE: 'bg-gray-100 text-gray-500',
  PENDING: 'bg-gray-100 text-gray-600',
  IN_PROGRESS: 'bg-blue-50 text-blue-700',
  GENERATED: 'bg-teal-50 text-teal-700',
  NEEDS_REVIEW: 'bg-amber-50 text-amber-700',
  APPROVED: 'bg-emerald-50 text-emerald-700',
  PUBLISHED: 'bg-emerald-100 text-emerald-800',
  FAILED: 'bg-red-50 text-red-600',
  SKIPPED: 'bg-gray-100 text-gray-500',
};

export const TOPIC_STATUS_LABELS = {
  NONE: 'Not started',
  PENDING: 'Pending',
  IN_PROGRESS: 'Generating',
  GENERATED: 'Generated',
  NEEDS_REVIEW: 'Needs Review',
  APPROVED: 'Approved',
  PUBLISHED: 'Published',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
};

export const statusLabel = (s) => TOPIC_STATUS_LABELS[s] || String(s || '').replace(/_/g, ' ');
export const statusTone = (s) => TOPIC_STATUS_TONES[s] || TOPIC_STATUS_TONES.NONE;

/** Statuses whose markdown an admin may edit / review. */
export const EDITABLE_STATUSES = ['GENERATED', 'NEEDS_REVIEW', 'APPROVED', 'PUBLISHED', 'FAILED'];
export const APPROVABLE_STATUSES = ['GENERATED', 'NEEDS_REVIEW'];
export const REQUEST_CHANGES_STATUSES = ['GENERATED', 'NEEDS_REVIEW', 'APPROVED', 'PUBLISHED'];

/** Route of the full-screen Content Workspace for a topic. */
export const contentWorkspacePath = (slug, topicId) =>
  `/superadmin/elite-technologies/content/${encodeURIComponent(topicId)}?tech=${encodeURIComponent(slug)}`;

/** Route back to the Generation Monitor for a technology (state-driven page, re-opened via query). */
export const generationMonitorPath = (slug) =>
  `/superadmin/elite-technologies?tech=${encodeURIComponent(slug)}&view=monitor`;
